import React, { useState, useEffect } from "react";
import Heading from "../UI/Heading";
import axios from "axios";

const OurExpertise = () => {
  const [webTools, setWebTools] = useState([]);
  const [digitalTools, setDigitalTools] = useState([]);
  const [loadMore, setLoadMore] = useState(6);
  const [digitalView, setDigitalView] = useState(6);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [digitalButtonDisabled, setDigitalButtonDisabled] = useState(false);

  useEffect(() => {
    axios.get("https://admin.socioloom.com/api/get_expertise.php")
      .then(response => {
        const { web_development, digital_marketing } = response.data.data;
        setWebTools(web_development);
        setDigitalTools(digital_marketing);
      })
      .catch(error => {
        console.error("Error fetching tools:", error);
      });
  }, []);

  // ✅ Protect against undefined by checking arrays
  const slice = Array.isArray(webTools) ? webTools.slice(0, loadMore) : [];
  const slice_2 = Array.isArray(digitalTools) ? digitalTools.slice(0, digitalView) : [];

  const handleMore = () => {
    const newLoadMore = loadMore + 6;
    setLoadMore(newLoadMore);
    if (newLoadMore >= webTools.length) {
      setIsButtonDisabled(true);
    }
  };

  const handleDigitalShow = () => {
    const newDigitalLoadMore = digitalView + 6;
    setDigitalView(newDigitalLoadMore);
    if (newDigitalLoadMore >= digitalTools.length) {
      setDigitalButtonDisabled(true);
    }
  };

  return (
    <>
      <Heading heading={"Our Expertise"} text={"4xl"} height={"100px"} />

      <div className="flex items-center justify-center px-28 max-sm:px-0 max-md:px-0 max-md:flex-wrap max-sm:flex-wrap max-sm:h-[100%] max-md:h-[100%] h-[600px] overflow-y-scroll">

        {/* Web Development Tools Section */}
        <section className="w-full mx-auto sm:px-6 max-md:h-[100%] max-sm:h-[100%] h-full">
          <div className="flex items-center justify-center">
            <div className="max-w-md mx-auto space-y-6 w-full">
              <h2 className="flex flex-row flex-nowrap items-center my-8">
                <span className="flex-grow block border-t border-[#fff]" />
                <span className="flex-none block px-4 py-2.5 text-2xl max-md:text-xl font-medium uppercase text-[#07c991a8]">
                  Technologies
                </span>
                <span className="flex-grow block border-t border-[#fff]" />
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 max-sm:grid-cols-2 max-md:grid-cols-3 lg:grid-cols-3 gap-4 border-2 rounded-md">
            {slice.map((item, index) => (
              <div className="rounded-lg flex flex-col justify-center items-center" key={index}>
                <div className="mb-8 py-2">
                  <img className="object-center object-cover rounded h-16 w-16" src={item?.image_url} alt={item?.name} />
                </div>
                <div className="text-center">
                  <p className="text-sm text-gray-700 font-bold mb-2">{item?.name}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-center justify-center md:flex-row w-full">
            <button
              className={`mb-3 inline-flex h-12 w-full items-center justify-center rounded bg-[#07c991a8] px-6 font-medium tracking-wide text-white shadow-md transition ${
                !isButtonDisabled ? "hover:bg-transparent" : "bg-[#E5E8E8]"
              } ${!isButtonDisabled ? "cursor-pointer" : "cursor-not-allowed"} ${
                !isButtonDisabled ? "hover:text-[#07c991a8]" : "text-[#566573]"
              } hover:border focus:outline-none md:mr-4 md:mb-0 md:w-auto`}
              onClick={handleMore}
              disabled={isButtonDisabled}
            >
              View More
            </button>
          </div>
        </section>

        {/* Digital Marketing Tools Section */}
        <section className="w-full mx-auto sm:px-6 lg:px-4 max-md:h-[100%] max-sm:h-[100%] h-full">
          <div className="flex items-center justify-center">
            <div className="max-w-md mx-auto space-y-6 w-full">
              <h2 className="flex flex-row flex-nowrap items-center my-8">
                <span className="flex-grow block border-t border-[#fff]" />
                <span className="flex-none block px-4 py-2.5 text-2xl max-md:text-xl font-medium uppercase text-[#07c991a8]">
                  Digital Marketing Tools
                </span>
                <span className="flex-grow block border-t border-[#fff]" />
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 max-sm:grid-cols-2 max-md:grid-cols-3 lg:grid-cols-3 gap-4 border-2 rounded-md">
            {slice_2.map((item, index) => (
              <div className="rounded-lg flex flex-col justify-center items-center" key={index}>
                <div className="mb-8 py-2">
                  <img className="object-center object-cover rounded h-16 w-16" src={item?.image_url} alt={item?.name} />
                </div>
                <div className="text-center">
                  <p className="text-sm text-gray-700 font-bold mb-2">{item?.name}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-center justify-center md:flex-row w-full">
            <button
              className={`mb-3 inline-flex h-12 w-full items-center justify-center rounded bg-[#07c991a8] px-6 font-medium tracking-wide text-white shadow-md transition ${
                !digitalButtonDisabled ? "hover:bg-transparent" : "bg-[#E5E8E8]"
              } ${!digitalButtonDisabled ? "cursor-pointer" : "cursor-not-allowed"} ${
                !digitalButtonDisabled ? "hover:text-[#07c991a8]" : "text-[#566573]"
              } hover:border focus:outline-none md:mr-4 md:mb-0 md:w-auto`}
              onClick={handleDigitalShow}
              disabled={digitalButtonDisabled}
            >
              View More
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default OurExpertise;
